<template lang="pug">
  div.externally-paginated-table
    v-data-table(
      :headers="headers"
      :items="data"
      :server-items-length="numberOfRecords"
      :loading="loading"
      dense
      @update:page="pageChange($event)"
      :items-per-page="itemsPerPage"
      @update:items-per-page="itemsPerPage=$event;pageChange(1)"
      :footer-props="{ itemsPerPageOptions: [5, 10, 20] }"
      :hide-default-footer="hideFooter"
    )
      template(v-slot:footer.page-text="{pageStart, pageStop}")
        div Displaying rows {{pageStart}} - {{pageStop}}
</template>

<script>
import axios from 'axios'

export default {
  props: ['url', 'numberOfRecords'],
  data: () => ({
    data: [],
    loading: false,
    headers: [],
    itemsPerPage: 10,
    hideFooter: false
  }),
  watch: {
    url() {
      this.begin()
    }
  },
  methods: {
    getDataFromApi(top=1, skip=0) {
      this.loading = true
      let adjustedUrl
      if(this.url.includes('?'))
        adjustedUrl = this.url.replace('?', `?$top=${top}&$skip=${skip}&`)
      else
        adjustedUrl = `${this.url}?$top=${top}&$skip=${skip}`
      return axios.get(adjustedUrl).then(response => {
        this.loading = false
        return response.data
      })
    },
    pageChange(page) {
      this.getDataFromApi(this.itemsPerPage, this.itemsPerPage*(page-1)).then(data => {
        this.data = data
      })
    },
    begin() {
      this.getDataFromApi(1,0).then(data => {
        this.headers = Object.keys(data[0]).map(header => {
          return {
            text: header,
            value: header,
            sortable: false,
            align: 'start',
            divider: true
          }
        })
      })
      this.getDataFromApi(this.itemsPerPage,0).then(data => {
        this.data = data
      })
    }
  },
  mounted() {
    if (!this.numberOfRecords) {
      //fail safe check in case numberOfRecords is null
      this.numberOfRecords = 1000;
      this.hideFooter = true;
    }
    this.begin()
  }
}
</script>

<style lang="stylus">
  .externally-paginated-table
    th, td
      font-family: 'Roboto Mono', monospace
</style>